module.exports = __webpack_public_path__ + "img/upi_payments.c319de43.gif";